import { Type, type Static } from "@sinclair/typebox";
import { UuidSchema } from "./identifiers.ts";

const TimestampSchema = Type.String({ format: "date-time" });

export const TrialApplicationInputSchema = Type.Object(
  {
    email: Type.String({ format: "email", maxLength: 320 })
  },
  { additionalProperties: false }
);
export type TrialApplicationInput = Static<typeof TrialApplicationInputSchema>;

export const TrialApplicationSchema = Type.Object(
  {
    trialApplicationId: UuidSchema,
    email: Type.String({ format: "email", maxLength: 320 }),
    submittedAt: TimestampSchema,
    lastSubmittedAt: TimestampSchema,
    submissionCount: Type.Integer({ minimum: 1 })
  },
  { additionalProperties: false }
);
export type TrialApplication = Static<typeof TrialApplicationSchema>;

export const TrialApplicationPageSchema = Type.Object(
  {
    applications: Type.Array(TrialApplicationSchema, { maxItems: 200 }),
    nextPage: Type.Union([Type.Integer({ minimum: 2 }), Type.Null()])
  },
  { additionalProperties: false }
);
export type TrialApplicationPage = Static<typeof TrialApplicationPageSchema>;

export const TrialApplicationAcceptedSchema = Type.Object(
  { accepted: Type.Literal(true) },
  { additionalProperties: false }
);
export type TrialApplicationAccepted = Static<typeof TrialApplicationAcceptedSchema>;
